import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function vazaoPosto(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@vazaoPosto/FIND_DATA':
      case '@vazaoPosto/UPDATE_DATA':
      case '@vazaoPosto/DELETE_DATA':
      case '@vazaoPosto/STORE_DATA':
      case '@vazaoPosto/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@vazaoPosto/SUCCESS_REMOVE':
      case '@vazaoPosto/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@vazaoPosto/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@vazaoPosto/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@vazaoPosto/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = action.payload.params;
        break;
      }

      case '@vazaoPosto/UPDATE_NOZZLE': {
        draft.find = {
          ...draft.find,
          bicos: draft.find.bicos.map((bico, key) =>
            key === action.payload.position
              ? { ...bico, pobi_vazao_maxima: action.payload.value }
              : bico
          ),
        };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
